export default __webpack_public_path__ + "static/media/ecgrow_logo-404.f9bd7656.png";